import React, { useState } from "react";

interface ITabIdContextState {
  tabId: number;
}
export const TabIdContext = React.createContext<ITabIdContextState | undefined>(undefined);

export const useTabIdContext = () => {
  const context = React.useContext(TabIdContext);
  if (context === undefined) {
    throw new Error("useTabIdContext must be used within a Provider");
  }
  return context;
};

export const TabIdContextComponent: React.FC = ({ children }) => {
  const [tabId, setTabId] = useState<number>(0);

  React.useEffect(() => {
    const currentTabId = (sessionStorage.tabId = Math.random());
    setTabId(currentTabId);
  }, []);

  return <TabIdContext.Provider value={{ tabId }}>{children}</TabIdContext.Provider>;
};

export default TabIdContextComponent;
